import React from 'react';
import { 
	PUBLIC_LABEL, 
	CONFIDENTIAL_LABEL, 
	IS_PUBLIC_FIELD, 
	ATTACHMENT_FIELD, 
	REMOVE_ATTACHMENT_FIELD, 
	DOCKET_PREFIX_FIELD, 
	SEQUENCE_NUM_FIELD, 
	SUBSEQUENCE_NUM_FIELD, 
	DOCKET_SUFFIX_FIELD, 
	HAC_FIELD, 
	FORMAL_FILING_FORM_TYPE, 
	OTHER_FILING_FORM_TYPE, 
	RECORDATION_FORM_TYPE, 
	RECORDATION_OPTION_FIELD,
	RECORDATION_WATER_RAIL_FIELD,
	RECORDATION_WATER_RAIL_OPTIONS,
	HAC_OPTIONS, 
	RECORDATION_OPTIONS, 
	DOCKET_NUM_FIELDS, 
	DOCKET_NUM_LABEL, 
	DOCKET_NUM_FIELD, 
	RECORDATION_CATEGORY_FIELD, 
	RECORDATION_CATEGORY_LABEL, 
	RCPA_FORM_TYPE,
	REGION_FIELD,
	ENVIRONMENTAL_COMMENTS_FORM_TYPE,
	ENVCOM_TYPE_LABEL,
	ENVCOM_TYPE_ID_FIELD,
	ENVCOM_HAVE_DOCKETS_FIELD,
	EFILING_SUBMIT_CHECKBOX_FIELD
} from '../../../resources/constants/fields';
import { 
	CHOOSE_FILE_BUTTON_LABEL, 
	ACCEPTED_FORMATS, 
	SUBMISSION_REQUIREMENTS, 
	SUBMISSION_REQUIREMENTS_RECORDATIONS, 
	FILE_SECTION_TITLE, 
	FILE_FORMATS_TITLE, 
	SUBMISSION_REQS_TITLE, 
	ADD_ATTACHMENT_BUTTON_LABEL, 
	ADD_PARTY_BUTTON_LABEL, 
	PARTY_SECTION_TITLE, 
	PARTY_SECTION_DESCRIPTION, 
	PARTY_DIV_ID, 
	SUBMIT_FORMAL_BUTTON_LABEL, 
	SUBMIT_INFORMAL_BUTTON_LABEL, 
	ATTACHMENTS_DIV_ID, 
	RECORDATION_INFO_INTRO, 
	RECORDATION_INFO_FEE, 
	RECORDATION_INFO_NOTICE, 
	RECORDATION_INFO_INSTRUCTIONS, 
	REGION_HINT_ID,
	RCPA_INFO,
	ENV_COMMENT_INFO,
	ACCEPTED_FORMATS_ENVCOM,
	SUBMISSION_REQUIREMENTS_ENVCOM,
	CHAR_COUNT_ID,
	ENVCOM_FILE_FORMATS_TITLE,
	ACCEPTED_FORMATS_FORMAL,
	SUBMISSION_REQUIREMENTS_FORMAL,
	FORMAL_FILE_FORMATS_TITLE,
	EFILNG_SUBMIT_CHECKBOX_LABEL,
	ENVCOM_SUBMIT_CHECKBOX_LABEL
} from '../../../resources/constants/ui';
import { 
	DOCKET_PREFIXES, 
	DOCKET_SUFFIXES, 
	ENV_COMM_TYPES, 
	RECORDATION_CATEGORIES, 
	REGIONS
} from '../../../resources/constants/dropdowns';
import { 
	MARGIN, 
	LABEL_SIZE, 
	INPUT_SIZE 
} from '../../../resources/constants/dimensions';
import { PlusIcon } from '../../../resources/media/PlusIcon';
import { TrashIcon } from '../../../resources/media/TrashIcon';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { getFieldError } from '../util/validation';
import { 
	NO_LABEL_ERROR, 
	MAX_ATTACHMENTS_ERROR, 
	MAX_PARTIES_ERROR, 
	INVALID_ICON, 
	PDF_REQUIREMENT_ERROR
} from '../../../resources/constants/errors';
import { WIDTH } from '../../../resources/constants/dimensions';
import { 
	OtherFilingFields, 
	FormalFilingFields, 
	RecordationFields, 
	RCPAFields,
	EnvironmentalCommentFields
} from './FormLayouts';
import { PARTY_LIMITS } from '../../../resources/constants/validations';
import { DynamicFormRow } from '../../Search/components/common';

export function Label(props) {
	return <label htmlFor={props.for}>{props.text}</label>;
}

export function RecordationRadioButton(props) {
	const recordationOptions = [...RECORDATION_OPTIONS];
	return (
		<div className="vert-center">
			{recordationOptions.map((_, idx) => (
				<RadioButton
					id={`${RECORDATION_OPTION_FIELD}-${idx}`}
					name={RECORDATION_OPTION_FIELD}
					className={RECORDATION_OPTION_FIELD}
					checked={props.value === recordationOptions[idx].value}
					value={recordationOptions[idx].value}
					label={recordationOptions[idx].label}
					key={`${recordationOptions[idx].value}-${idx}`}
					handleChange={props.handleChange}
					inline={props.inline}
					isInvalid={props.isInvalid}
				/>
			))}
		</div>
	)
}

export function RecordationWaterRailRadioButton(props) {
	const recordationOptions = [...RECORDATION_WATER_RAIL_OPTIONS];
	return (
		<div className="vert-center">
			{recordationOptions.map((_, idx) => (
				<RadioButton
					id={`${RECORDATION_WATER_RAIL_FIELD}-${idx}`}
					name={RECORDATION_WATER_RAIL_FIELD}
					className={RECORDATION_WATER_RAIL_FIELD}
					checked={props.value === recordationOptions[idx].value}
					value={recordationOptions[idx].value}
					label={recordationOptions[idx].label}
					key={`${recordationOptions[idx].value}-${idx}`}
					handleChange={props.handleChange}
					inline={props.inline}
					isInvalid={props.isInvalid}
				/>
			))}
		</div>
	)
}

export function HacRadioButton(props) {
	const hacOptions = [...HAC_OPTIONS];
	return (
		<div className="vert-center">
			{hacOptions.map((_, idx) => (
				<RadioButton
					id={`${HAC_FIELD}-${idx}`}
					name={HAC_FIELD}
					className={HAC_FIELD}
					checked={props.value === hacOptions[idx].value}
					value={hacOptions[idx].value}
					label={hacOptions[idx].label}
					key={`${hacOptions[idx].value}-${idx}`}
					handleChange={props.handleChange}
					inline={props.inline}
				/>
			))}
		</div>
	)
}

export function RegionRadioButton(props) {
	const regions = [...REGIONS];
	var className = "vert-center";
	if(props.isInvalid){
		className += " invalid-border-radio";
	}
	return (
		<div className={className}>
			{regions.map((_, idx) => (
				<RadioButton
					id={`${REGION_FIELD}-${idx}`}
					name={REGION_FIELD}
					className={REGION_FIELD}
					color={regions[idx].color}
					ariaLabel={`${regions[idx].name}: ${regions[idx].hint}`}
					checked={props.value === regions[idx].name}
					value={regions[idx].name}
					label={regions[idx].name}
					key={`${regions[idx].name}-${idx}`}
					handleChange={props.handleChange}
					onMouseEnter={()=>showRegionHint(regions[idx])}
					onMouseLeave={()=>hideRegionHint(regions[idx])}
					inline={props.inline}
					isInvalid={props.isInvalid}
				/>
			))}
		</div>
	)
}

export function HaveDocketsRadioButton(props) {
	const options = [{label: "Yes", value: "true"}, {label: "No", value: "false"}];
	return (
		<div className="vert-center">
			{options.map((_, idx) => (
				<RadioButton
					id={`${ENVCOM_HAVE_DOCKETS_FIELD}-${idx}`}
					name={ENVCOM_HAVE_DOCKETS_FIELD}
					className={ENVCOM_HAVE_DOCKETS_FIELD}
					checked={props.value === options[idx].value}
					value={options[idx].value}
					label={options[idx].label}
					key={`${options[idx].value}-${idx}`}
					handleChange={props.handleChange}
					inline={props.inline}
					isInvalid={props.isInvalid}
				/>
			))}
		</div>
	)
}

const showRegionHint = region => {
	document.getElementById(REGION_HINT_ID).style.display="block";
	document.getElementById(REGION_HINT_ID).style.color=region.color;
	document.getElementById(REGION_HINT_ID).style.borderColor=region.color;
	document.getElementById(REGION_HINT_ID).innerHTML = region.hint;
}

const hideRegionHint = name => {
	document.getElementById(REGION_HINT_ID).style.display="none";
}

export function CategoryRadioButton(props) {
	const options = [...RECORDATION_CATEGORIES];
	var selectedOption = props.fields[RECORDATION_CATEGORY_FIELD] ? props.fields[RECORDATION_CATEGORY_FIELD] : options[0].value;
	return (
		<DynamicFormRow>
			<Form.Label 
				className="vert-center pad-left" 
				size={6}
			>
				{RECORDATION_CATEGORY_LABEL}
			</Form.Label>
			<div 
				size={6} 
				className="vert-center"
			>
				{options.map((val, idx) => (
					<RadioButton
						id={`${RECORDATION_CATEGORY_FIELD}-${idx}`}
						name={RECORDATION_CATEGORY_FIELD}
						className={HAC_FIELD}
						checked={selectedOption === options[idx].value}
						value={options[idx].value}
						label={options[idx].label}
						key={`${options[idx].value}-${idx}`}
						handleChange={props.handleChange}
						inline={props.inline}
					/>
				))}
			</div>
		</DynamicFormRow>
	)
}

export function EnvCommTypeRadioButton(props) {
	const options = [...ENV_COMM_TYPES];
	var selectedOption = Number(props.fields[ENVCOM_TYPE_ID_FIELD] ? props.fields[ENVCOM_TYPE_ID_FIELD] : options[0].value);
	return (
		<DynamicFormRow>
			<Form.Label 
				className="vert-center pad-left" 
				size={4}
			>
				{ENVCOM_TYPE_LABEL}
			</Form.Label>
			<div 
				size={8} 
				className="vert-center"
			>
				{options.map((val, idx) => (
					<RadioButton
						id={`${ENVCOM_TYPE_ID_FIELD}-${idx}`}
						name={ENVCOM_TYPE_ID_FIELD}
						className={HAC_FIELD}
						checked={selectedOption === options[idx].value}
						value={options[idx].value}
						label={options[idx].label}
						key={`${options[idx].value}-${idx}`}
						handleChange={props.handleChange}
						inline={props.inline}
					/>
				))}
			</div>
		</DynamicFormRow>
	)
}

export function RadioButton(props) {
	let inline = props.inline
		? "radio-container inline-block"
		: "radio-container";
	if(props.isInvalid){
		inline = inline + " invalid-radio";
	}
	return (
		<div 
			className={inline} 
			title={props.title}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
		>
			<label 
				style={props.color ? {color:props.color} : null}
				aria-label={props.ariaLabel}
			>
				{props.label}
				<input
					type="radio"
					id={props.id}
					name={props.name}
					className={props.className}
					data-id={props.index}
					checked={props.checked}
					value={props.value}
					onChange={props.handleChange}
					required={props.required}
				/>
				<span className="radio" style={props.checked ? {backgroundColor: props.color}:null} id={props.name} name={props.name} />
			</label>
		</div>
	);
}

export function PublicRadioButton(props) {
	const publicOptions = [
		{ label: PUBLIC_LABEL, value: true },
		{ label: CONFIDENTIAL_LABEL, value: false }
	];
	return publicOptions.map((val, idx) => (
		<RadioButton
			id={`${props.id}-${idx}`}
			name={`${props.name}-${idx}`}
			className={IS_PUBLIC_FIELD}
			index={props.index}
			key={`${props.index}-${idx}`}
			checked={props.value === publicOptions[idx].value}
			value={publicOptions[idx].value}
			label={publicOptions[idx].label}
			handleChange={props.handleChange}
		/>
	));
}

class FileUploadField extends React.Component {
	constructor(props) {
		super(props);
		this.fileUpload = React.createRef();
	}
	render() {
		return (
			<Form.Control
				type="file"
				id={this.props.id}
				ref={this.fileUpload}
				name={this.props.id}
				data-id={this.props.index}
				className={`${this.props.name} ${this.props.className}`}
				onChange={this.props.handleChange}
				onClick={this.props.onClick}
				required={this.props.required}
				isInvalid={this.props.isInvalid}
			/>
		);
	}
}

export function AttachmentWithPrivacy(props) {
	return props.attachments.map((val, idx) => {
		let attachmentId = `${ATTACHMENT_FIELD}-${idx}`;
		let isPublicId = `${IS_PUBLIC_FIELD}-${idx}`;
		let buttonClass =
			"attachment-btn stb-btn-width attachment-box__btn--margin";
		let spacingClass = props.inline ? "choose-file-btn--inline" : "choose-file-btn";
		let remove = null;
		let str = CHOOSE_FILE_BUTTON_LABEL;
		let invalid = props.errors
			.filter(error => error.fieldId === attachmentId)
			.reduce((acc, cur) => [...acc, cur.errorMsg + "\n"], []);
		if(invalid.length){
			invalid = invalid[0];
		}
		let isInvalid =
			props.errors.filter(error => error.fieldId === attachmentId)
				.length > 0;
		let fileName = "";
		let file = val.state.file;
		if (file !== null && file !== undefined && file !== "") {
			fileName = file.name.split("\\");
			fileName = (
				<p className={"stb-filename"}>
					{fileName[fileName.length - 1]}
				</p>
			);
		}
		let button = (
			<React.Fragment>
				<label className={buttonClass}>
					<FileUploadField
						id={attachmentId}
						name={ATTACHMENT_FIELD}
						className="hide"
						index={idx}
						value={val.state.file}
						handleChange={props.handleChange}
						onClick={props.onClick}
						isInvalid={isInvalid}
					/>
					{str}
				</label>
			</React.Fragment>
		);
		if (
			props.attachments.length > 1 || 
			/* Attachments are optional for RCPA or Environmental Comment eFilings */
			(props.formType && [RCPA_FORM_TYPE, ENVIRONMENTAL_COMMENTS_FORM_TYPE].includes(props.formType))
		) {
			remove = (
				<div className={"stb-remove-attachment"}>
					<Button
						id={`${REMOVE_ATTACHMENT_FIELD}-${idx}`}
						variant={"danger"}
						onClick={() => props.remove(idx)}
						value={idx}
						className={
							"stb-remove-attachment__btn attachment-box__btn--margin transparent-btn-danger"
						}
					>
						<TrashIcon />
					</Button>
				</div>
			);
		}
		return (
			<div key={"attachmentDiv" + idx} className="attachment-box">
				<div className={spacingClass}>
					{fileName}
					{button}
				</div>
				{props.withPublic ? <div className="">
					<PublicRadioButton
						id={isPublicId}
						name={isPublicId}
						index={idx}
						value={props.public[idx]}
						handleChange={props.handleChange}
					/>
				</div> : null}
				{remove}
				<span className={"attachment-error"}>
					<Form.Control isInvalid={isInvalid} className={"hide"} />
					<Form.Control.Feedback type={"invalid"}>
						{invalid}
					</Form.Control.Feedback>
				</span>
			</div>
		);
	});
}

export function SelectOptions(props) {
	let options = [];
	props.options.map((opt, idx) => {
		if(opt === "") {
			return options.push(
				<option value="" key={idx} style={{"display":"none"}}></option>
			);
		} else if(typeof opt === "string") {
			return options.push(
				<option key={`${opt}-${idx}`} value={opt}>
					{opt}
				</option>
			);
		} else if(typeof opt === "object") {
			return options.push(
				<option key={`${opt.name}-${idx}`} value={opt.abbrv}>
					{`${opt.abbrv} - ${opt.name}`}
				</option>
			)
		} else {
			return options.push(
				<option value="" key={idx} style={{"display":"none"}}></option>
			);
		}
	});
	return options;
}

export function DocketNumberFields(props) {
	var hasMultiple = props.docketNumbers.length > 1 || props.optional;
	var containerClass = hasMultiple ? "field-with-button" : "";
	var duplicateErrorCheck = props.errors.filter(error => error.fieldId.includes(DOCKET_NUM_FIELD));
	var duplicateErrorMessage = duplicateErrorCheck.length ? duplicateErrorCheck[0].errorMsg : null;
	var duplicateErrorIndex = duplicateErrorCheck.length ? Number(duplicateErrorCheck[0].fieldId.split('-')[1]) : null;
	return props.docketNumbers.map((docketNumber, index) => {
		var isDuplicate = index === duplicateErrorIndex;
		var duplicateRowClass = isDuplicate ? "invalid-docket-number" : "";
		var prefixError = getFieldError(props.errors, DOCKET_PREFIX_FIELD,index);
		var seqError = getFieldError(props.errors, SEQUENCE_NUM_FIELD, index);
		var subSeqError = getFieldError(props.errors, SUBSEQUENCE_NUM_FIELD, index);
		return (
			<React.Fragment key={`${DOCKET_NUM_FIELDS}-${index}`}>
				<CustomFormRow labelText={<span><RequiredSymbol />{DOCKET_NUM_LABEL}</span>}>
					<div className={containerClass}>
						<Row className={duplicateRowClass}>
							<Col sm={3}>
								<Form.Control
									required
									as="select"
									id={`${DOCKET_PREFIX_FIELD}-${index}`}
									name={`${DOCKET_PREFIX_FIELD}-${index}`}
									value={props.prefixValue || docketNumber.docketPrefix}
									onBlur={props.handleBlur}
									onChange={props.handleChange}
									isInvalid={
										props.errors.filter(
											error => error.fieldId === `${DOCKET_PREFIX_FIELD}-${index}`
										).length > 0
									}
								>
									<SelectOptions options={DOCKET_PREFIXES} />
								</Form.Control>
								{
									prefixError.length ?
									<Form.Control.Feedback type="invalid">
										{prefixError}
									</Form.Control.Feedback> : 
									null
								}
							</Col>
							<Col sm={3}>
								<Form.Control
									required
									type="text"
									id={`${SEQUENCE_NUM_FIELD}-${index}`}
									name={`${SEQUENCE_NUM_FIELD}-${index}`}
									className={"invalid-padding"}
									value={docketNumber.sequenceNumber}
									onBlur={props.handleBlur}
									onChange={props.handleChange}
									isInvalid={
										props.errors.filter(
											error => error.fieldId === `${SEQUENCE_NUM_FIELD}-${index}`
										).length > 0
									}
								/>
								{
									seqError.length ?
									<Form.Control.Feedback type="invalid" className="invalid-box">
										{INVALID_ICON(seqError)}
									</Form.Control.Feedback>
									: 
									null
								}
							</Col>
							<Col sm={3}>
								<Form.Control
									type="text"
									id={`${SUBSEQUENCE_NUM_FIELD}-${index}`}
									name={`${SUBSEQUENCE_NUM_FIELD}-${index}`}
									className={"invalid-padding"}
									value={docketNumber.subSequenceNumber}
									onBlur={props.handleBlur}
									onChange={props.handleChange}
									isInvalid={
										props.errors.filter(
											error => error.fieldId === `${SUBSEQUENCE_NUM_FIELD}-${index}`
										).length > 0
									}
								/>
								{
									subSeqError.length ?
									<Form.Control.Feedback type="invalid" className="invalid-box">
										{INVALID_ICON(subSeqError)}
									</Form.Control.Feedback>
									: null
								}
							</Col>
							<Col sm={3}>
								<Form.Control
									as="select"
									id={`${DOCKET_SUFFIX_FIELD}-${index}`}
									name={`${DOCKET_SUFFIX_FIELD}-${index}`}
									value={docketNumber.docketSuffix}
									onBlur={props.handleBlur}
									onChange={props.handleChange}
								>
									<SelectOptions options={DOCKET_SUFFIXES} />
								</Form.Control>
							</Col>
						</Row>
					</div>
					{
						hasMultiple ? (
							<Button
								className="field-btn remove-email__btn"
								variant="danger"
								onClick={() => {
									props.dispatch({type: "removeDocketNumber", index: index});
								}}
							>
								<TrashIcon />
							</Button>
						) : 
						null
					}
					{
						isDuplicate ? (
							<div className="duplicate-message--invalid">
								{duplicateErrorMessage}
							</div>
						) : 
						null
					}
				</CustomFormRow>
			</React.Fragment>
		);
	});
}

export const getTextField = (state, dispatch, field, label, optional) => {
	return (
		<FieldWithLabel
			optional={optional}
			id={field}
			name={field}
			labelText={label}
			handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
			handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
			isInvalid={
				state.form.errors.filter(
					error => error.fieldId === field
				).length > 0
			}
			invalid={getFieldError(state.form.errors, field)}
		/>
	);
}

export const getDropdownField = (state, dispatch, field, label, list, value, optional) => {
	var required = !optional;
	return (
		<CustomFormRow labelText={required ? <span><RequiredSymbol />{label}</span> : label}>
			<Form.Control
				required={required}
				as="select"
				name={field}
				id={field}
				value={value}
				onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error =>
							error.fieldId === field
					).length > 0
				}
				invalid={getFieldError(state.form.errors, field)}
			>
				<SelectOptions options={list} />
			</Form.Control>
		</CustomFormRow>
	);
}

export const getTextArea = (state, dispatch, field, label, rows, optional, maxChars) => {
	return (
		<TextAreaWithLabel
			optional={optional}
			id={field}
			name={field}
			labelText={label}
			value={state.data[field]}
			handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
			handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
			numRows={(rows || "5")}
			isInvalid={
				state.form.errors.filter(
					error => error.fieldId === field
				).length > 0
			}
			invalid={getFieldError(state.form.errors, field)}
			maxChars={maxChars}
		/>
	);
}

/*
Props:
Required: name, labelText
Optional: leftPad, rightPad, labelCol, inputCol, invalidMsg
*/
export function FieldWithLabel(props) {
	var required = !props.optional;
	var invalid = props.invalid || [];
	var left = props.leftPad || MARGIN || 1;
	var right = props.rightPad || MARGIN || 1;
	var label = props.labelCol || 12 - props.inputCol || LABEL_SIZE || 4;
	var input = props.inputCol || 12 - props.labelCol || INPUT_SIZE || 8;
	var text = props.labelText || props.name || NO_LABEL_ERROR;
	var hideClass = props.isVisible === false ? "hide-field" : "";
	var displayLabelAsTable = props.displayLabelAsTable || false;
	return (
		<Form.Row className={`${props.className} ${hideClass}`}>
			<Col lg={left} />
			<Form.Group as={Col} lg={12 - left - right}>
				<Row>
					<Col md={label}>
						{
							displayLabelAsTable ?
							(
								<Form.Label style={{"display": "table"}}>
									<span style={{"display": "table-row"}}>
										{required ? <RequiredSymbol /> : null}
										{text}
									</span>
								</Form.Label>
							) :
							(
								<Form.Label>
									<span>
										{required ? <RequiredSymbol /> : null}
										{text}
									</span>
								</Form.Label>
							)
						}
					</Col>
					<Col md={input}>
						<Form.Control
							required={required}
							id={props.id}
							type="text"
							name={props.name}
							value={props.value}
							placeholder={props.placeholder}
							onBlur={props.handleBlur}
							onChange={props.handleChange}
							isValid={props.isValid}
							isInvalid={props.isInvalid}
						/>
						{invalid.length ? 
						<Form.Control.Feedback type="invalid">
							{invalid}
						</Form.Control.Feedback>
						: null}
					</Col>
				</Row>
			</Form.Group>
			<Col lg={right} />
		</Form.Row>
	);
}

export function TextAreaWithLabel(props) {
	var required = !props.optional;
	var left = props.leftPad || MARGIN || 1;
	var right = props.rightPad || MARGIN || 1;
	var label = props.labelCol || 12 - props.inputCol || LABEL_SIZE || 4;
	var input = props.inputCol || 12 - props.labelCol || INPUT_SIZE || 8;
	var text = props.labelText || props.name || NO_LABEL_ERROR;
	var visible = props.isVisible || props.isVisible === undefined;
	var maxChars = props.maxChars;
	var value = props.value || "";
	var maxCharStyle = value.length > maxChars ? {color:"#dc3545"} : null;
	if (
		visible &&
		props.name != null &&
		props.name.length > 0 &&
		!props.name.includes(" ")
	) {
		return (
			<Form.Row>
				<Col lg={left} />
				<Form.Group as={Col} lg={12 - left - right}>
					<Row>
						<Col md={label}>
							<Form.Label>
								<span>
									{required ? <RequiredSymbol /> : null}
									{text}
								</span>
							</Form.Label>
						</Col>
						<Col md={input}>
								<Form.Control
									as="textarea"
									rows={props.numRows || "3"}
									required = {required}
									id={props.id}
									name={props.name}
									onChange={props.handleChange}
									onBlur={props.handleBlur}
									isValid={props.isValid}
									isInvalid={props.isInvalid}
								/>
								{maxChars ? 
								<div 
									id={`${props.id}-${CHAR_COUNT_ID}`} 
									className="character-count" 
									style={maxCharStyle}
								>
									{`${value.length}/${maxChars}`}
								</div>
								: null }
							<Form.Control.Feedback type="invalid">
								{props.invalid}
							</Form.Control.Feedback>
						</Col>
					</Row>
				</Form.Group>
				<Col lg={right} />
			</Form.Row>
		);
	}
	return null;
}

export function CustomFormRow(props) {
	var left = props.leftPad || MARGIN || 1;
	var right = props.rightPad || MARGIN || 1;
	var label = props.labelSize || 12 - props.inputSize || LABEL_SIZE || 4;
	var input = props.inputSize || 12 - props.labelSize || INPUT_SIZE || 8;
	var text = props.labelText || props.name || "";
	var visible = props.isVisible || props.isVisible === undefined;
	var displayLabelAsTable = props.displayLabelAsTable || false;
	if (visible) {
		return (
			<Form.Row>
				<Col lg={left} />
				<Form.Group as={Col} lg={12 - left - right}>
					<Row>
						<Col md={label}>
						{
							displayLabelAsTable ?
							(
								<Form.Label style={{"display": "table"}}>
									<span style={{"display": "table-row"}}>{text}</span>
								</Form.Label>
							) :
							<Form.Label>{text}</Form.Label>
						}
						</Col>
						<Col md={input}>{props.children}</Col>
					</Row>
				</Form.Group>
				<Col lg={right}/>
			</Form.Row>
		);
	}
	return null;
}

export function FormParagraph(props) {
	var visible = props.isVisible || props.isVisible === undefined;
	if (visible) {
		return (
			<Row className={props.className}>
				<Col lg={MARGIN} />
				<Form.Group as={Col} lg={WIDTH} className={props.className}>
					{props.children}
				</Form.Group>
				<Col lg={MARGIN} />
			</Row>
		);
	}
	return null;
}

export function FileFormats(props) {
	let acceptedFormats = ACCEPTED_FORMATS.map((format, index) => {
		return <li key={`file-format-${index}`}>{format}</li>;
	});
	let submissionReqsArray = SUBMISSION_REQUIREMENTS;
	if(props.pdfRequired){
		submissionReqsArray = [PDF_REQUIREMENT_ERROR, ...SUBMISSION_REQUIREMENTS];
	}
	let submissionReqs = submissionReqsArray.map((req, index) => {
		return <li key={`file-req-${index}`}>{req}</li>;
	});
	return (
		<FormParagraph>
			<h4>
				<strong>{FILE_SECTION_TITLE}</strong>
			</h4>
			<p>{FILE_FORMATS_TITLE} </p>
			<ul>{acceptedFormats}</ul>
			<p>{SUBMISSION_REQS_TITLE}</p>
			<ul>{submissionReqs}</ul>
		</FormParagraph>
	);
}

export function FileFormatsFormal(props) {
	let acceptedFormats = ACCEPTED_FORMATS_FORMAL.map((format, index) => {
		return <li key={`file-format-${index}`}>{format}</li>;
	});
	let submissionReqsArray = SUBMISSION_REQUIREMENTS_FORMAL;
	if(props.pdfRequired){
		submissionReqsArray = [PDF_REQUIREMENT_ERROR, ...SUBMISSION_REQUIREMENTS_FORMAL];
	}
	let submissionReqs = submissionReqsArray.map((req, index) => {
		return <li key={`file-req-${index}`}>{req}</li>;
	});
	return (
		<FormParagraph>
			<h4>
				<strong>{FILE_SECTION_TITLE}</strong>
			</h4>
			<p>{FORMAL_FILE_FORMATS_TITLE} </p>
			<ul>{acceptedFormats}</ul>
			<p>{SUBMISSION_REQS_TITLE}</p>
			<ul>{submissionReqs}</ul>
		</FormParagraph>
	);
}

export function FileFormatsEnvCom(props) {
	let acceptedFormats = ACCEPTED_FORMATS_ENVCOM.map((format, index) => {
		return <li key={`file-format-${index}`}>{format}</li>;
	});
	
	let submissionReqs = SUBMISSION_REQUIREMENTS_ENVCOM.map((req, index) => {
		return <li key={`file-req-${index}`}>{req}</li>;
	});
	return (
		<FormParagraph>
			<h4>
				<strong>{FILE_SECTION_TITLE}</strong>
			</h4>
			<p>{ENVCOM_FILE_FORMATS_TITLE} </p>
			<ul>{acceptedFormats}</ul>
			<p>{SUBMISSION_REQS_TITLE}</p>
			<ul>{submissionReqs}</ul>
		</FormParagraph>
	);
}

export function FileFormatRecordations() {
	let submissionReqs = SUBMISSION_REQUIREMENTS_RECORDATIONS.map((req, index) => {
		return <li key={`file-req-${index}`}>{req}</li>;
	});
	return (
		<FormParagraph>
			<h4>
				<strong>{SUBMISSION_REQS_TITLE}</strong>
			</h4>
			<ul>{submissionReqs}</ul>
		</FormParagraph>
	);
}

export function RecordationInfo() {
	return(
		<Row>
			<Col lg={1}/>
			<Col lg={10}>
				<div className="recordation-info panel">
					<p>{RECORDATION_INFO_INTRO}</p>
					<p>{RECORDATION_INFO_NOTICE}{" "}{RECORDATION_INFO_FEE}</p>
					<p>{RECORDATION_INFO_INSTRUCTIONS}</p>
				</div>
			</Col>
			<Col lg={1}/>
		</Row>
	)
}

export function RCPAInfo() {
	return(
		<Row>
			<Col lg={2}/>
			<Col lg={8}>
				<div>{RCPA_INFO}</div>
			</Col>
			<Col lg={2}/>
		</Row>
	)
}

export function EnvCommentInfo() {
	return(
		<Row>
			<Col lg={2}/>
			<Col lg={8}>
				<div>{ENV_COMMENT_INFO}</div>
			</Col>
			<Col lg={2}/>
		</Row>
	)
}

export function RequiredSymbol() {
	return <span className="required-symbol">{"* "}</span>;
}

export class AddButton extends React.Component {
	render() {
		return (
			<Button
				variant="primary"
				id={this.props.id}
				onClick={this.props.onClick}
				className={"transparent-btn-primary"}
			>
				<PlusIcon />
				<strong className="add-title">{this.props.children}</strong>
			</Button>
		);
	}
}

export const getAttachmentsSection = (state, dispatch) => {
	let attachmentButton = 	<div className="center">
		{state.data.attachments.length < state.form.maxAttachments ? (
			<AddButton onClick={() => dispatch({type: "addAttachment"}) }>
				{ADD_ATTACHMENT_BUTTON_LABEL}
			</AddButton>
			) : (
			<FormParagraph>
				<p className={"center"}>{MAX_ATTACHMENTS_ERROR}</p>
			</FormParagraph>
		)}
	</div>
	switch(state.form.type){
		case FORMAL_FILING_FORM_TYPE:
			return <>
				<div id="attachmentSection" key="attachmentSection">
					<FileFormatsFormal pdfRequired/>
					<br />
					<div id={ATTACHMENTS_DIV_ID}></div>
				</div>
				{attachmentButton}
			</>
		case OTHER_FILING_FORM_TYPE:
			return <>
				<div id="attachmentSection" key="attachmentSection">
					<FileFormats pdfRequired/>
					<br />
					<div id={ATTACHMENTS_DIV_ID}></div>
				</div>
				{attachmentButton}
			</>
		case RECORDATION_FORM_TYPE:
			return <div id="attachmentSection" key="attachmentSection">
				<FileFormatRecordations/>
				<br/>
				<div id={ATTACHMENTS_DIV_ID}></div>
			</div>
		case RCPA_FORM_TYPE:
			return <>
				<div id="attachmentSection" key="attachmentSection">
					<FileFormats/>
					<br/>
					<div id={ATTACHMENTS_DIV_ID}></div>
				</div>
				{attachmentButton}
			</>
		case ENVIRONMENTAL_COMMENTS_FORM_TYPE:
			return <>
				<div id="attachmentSection" key="attachmentSection">
					<FileFormatsEnvCom/>
					<br/>
					<div id={ATTACHMENTS_DIV_ID}></div>
				</div>
				{attachmentButton}
			</>
			
		default:
			return null;
	}
}

export const getPartySection = (state, dispatch) => {
	if(state.data.parties){
		let addPartyButton = state.data.parties.length < PARTY_LIMITS[state.form.type].max ? (
			<AddButton onClick={() => dispatch({type: "addParty"})}
			>
				{ADD_PARTY_BUTTON_LABEL}
			</AddButton>
		) : (
			<FormParagraph>
				<p className={"center"}>{MAX_PARTIES_ERROR}</p>
			</FormParagraph>
		);
		switch(state.form.type){
			case FORMAL_FILING_FORM_TYPE:
			case OTHER_FILING_FORM_TYPE:
				return <div id="partySection" key="partySection">
					<FormParagraph>
						<h3>
							<strong>{PARTY_SECTION_TITLE}</strong>
						</h3>
						<p>{PARTY_SECTION_DESCRIPTION}</p>
					</FormParagraph>
					<div id={PARTY_DIV_ID} />
					<div className={"center"}>{addPartyButton}</div>
				</div>;
			case RECORDATION_FORM_TYPE:
				return <div id="partySection" key="partySection">
					<div id={PARTY_DIV_ID} />
					<div className={"center"}>{addPartyButton}</div>
				</div>;
			default:
				return <></>;
		}
	}
	else {
		return null;
	}
}

export const getFieldsForType = (state, dispatch) => {
	if(state.form.type === OTHER_FILING_FORM_TYPE){
		return OtherFilingFields(state,dispatch);
	}
	else if(state.form.type === FORMAL_FILING_FORM_TYPE){
		return FormalFilingFields(state,dispatch);
	}
	else if(state.form.type === RECORDATION_FORM_TYPE){
		return RecordationFields(state, dispatch);
	}
	else if(state.form.type === RCPA_FORM_TYPE){
		return RCPAFields(state, dispatch);
	}
	else if(state.form.type === ENVIRONMENTAL_COMMENTS_FORM_TYPE){
		return EnvironmentalCommentFields(state, dispatch);
	}
}

export const getSubmitButtonLabel = state => {
	switch(state.form.type){
		case FORMAL_FILING_FORM_TYPE:
			return SUBMIT_FORMAL_BUTTON_LABEL;
		case OTHER_FILING_FORM_TYPE:
			return SUBMIT_INFORMAL_BUTTON_LABEL;
		default:
			return SUBMIT_INFORMAL_BUTTON_LABEL;
	}
}

export const getEFilingSubmitCheckboxLabel = state => {
	switch(state.form.type){
		case ENVIRONMENTAL_COMMENTS_FORM_TYPE:
			return ENVCOM_SUBMIT_CHECKBOX_LABEL;
		default:
			return EFILNG_SUBMIT_CHECKBOX_LABEL;

	}
}

export const getEFilingSubmitCheckbox = (state, dispatch) => {
	switch(state.form.type){
		case RCPA_FORM_TYPE:
			return <></>;
		default:
			return <div className='center efiling-checkbox'>
			<label>
				<input
				type="checkbox"
				id={EFILING_SUBMIT_CHECKBOX_FIELD}
				name={EFILING_SUBMIT_CHECKBOX_FIELD}
				checked={state.data[EFILING_SUBMIT_CHECKBOX_FIELD]}
				onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				/>
				<Label text={getEFilingSubmitCheckboxLabel(state)}/>
			</label>
			</div>;
	}
}